<template>
  <div
    ref="chart"
    style="height: 500px;"
  />
</template>

<script>
import echarts from 'echarts';

import { baseLineOption } from './config';
import { getYAxisMax } from '../../util';

export default {
  props: {
    // 源数据
    dataSource: {
      type: Object,
      default() {
        return {};
      },
    },

    // y轴名称
    yAxisNames: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      // echart 实例
      chart: null,
      // 原始数据
      data: this.dataSource,
      // 对比类型
      // y y轴对比
      // x x轴对比
      constrastType: 'y',
    };
  },

  computed: {
    // 基础数据
    baseData() {
      // 指标的对比数据包含在基础数据中
      const arr = [];
      const { data } = this.data;
      if (data) {
        const [d1, d2] = this.yAxisNames;
        if (d1) {
          arr[0] = data.map((item) => item[d1.value]);
        }
        if (d2) {
          arr[1] = data.map((item) => item[d2.value]);
        }
      }
      return arr;
    },

    // 对比数据
    // 由时间对比变更产生的数据
    contrastData() {
      const { compare_data: compareData } = this.data;
      if (compareData) {
        const [d1] = this.yAxisNames;
        return compareData.map((item) => item[d1.value]);
      }
      return [];
    },

    // 基础数据x轴
    baseXAxisData() {
      const { data } = this.data;
      if (data) {
        return data.map((item) => item.from_date);
      }
      return [];
    },

    // 对比数据x轴
    contrastXAxisData() {
      const { compare_data: compareData } = this.data;
      if (compareData) {
        return compareData.map((item) => item.from_date);
      }
      return [];
    },
  },

  watch: {
    dataSource(newVal) {
      this.data = newVal;

      if (this.data.compare_data) {
        this.constrastType = 'x';
      } else {
        this.constrastType = 'y';
      }

      this.render();
    },
  },

  mounted() {
    this.chart = echarts.init(this.$refs['chart']);
  },

  methods: {
    render() {
      const customOption = {
        xAxis: [],
        yAxis: [],
        series: [],
      };

      // 初始化数据
      if (this.constrastType === 'y') {
        this.baseData.forEach((data, index) => {
          // 坐标轴名称
          const name = this.yAxisNames[index].label;

          // 初始化series
          customOption.series.push({
            data,
            type: 'line',
            name,
            yAxisIndex: index,
          });

          // 初始化y轴坐标
          // const min = Math.min.apply(null, data);
          const min = 0;
          const max = getYAxisMax(Math.max.apply(null, data));
          const splitNumber = 5;
          const interval = (max - min) / splitNumber;

          customOption.yAxis.push({
            type: 'value',
            name,
            min,
            max,
            splitNumber,
            interval,
          });
        });

        // 初始化x轴坐标
        customOption.xAxis.push({
          type: 'category',
          data: this.baseXAxisData,
        });
      } else if (this.constrastType === 'x') {
        const x1 = this.baseXAxisData;
        const x2 = this.contrastXAxisData;
        // 坐标轴名称
        const baseName = `${x1[0]} ~ ${x1[x1.length - 1]}`;
        const contrastName = `${x2[0]} ~ ${x2[x2.length - 1]}`;

        // 初始化 series
        customOption.series.push({
          data: this.baseData[0],
          type: 'line',
          name: baseName,
        });
        customOption.series.push({
          data: this.contrastData,
          type: 'line',
          name: contrastName,
        });

        // 初始化y轴坐标
        const temp = this.baseData[0].concat(this.contrastData);
        const min = 0;
        // const min = Math.min.apply(null, temp);
        const max = getYAxisMax(Math.max.apply(null, temp));
        customOption.yAxis.push({ type: 'value', name, min, max });

        // 初始化x轴坐标
        customOption.xAxis.push({
          type: 'category',
          position: 'bottom',
          data: x1,
        });
        customOption.xAxis.push({
          type: 'category',
          position: 'bottom',
          offset: 30,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          data: x2,
        });
      }

      const option = Object.assign(baseLineOption, customOption);
      this.chart.setOption(option, true);
    },

    formatXAxisData() {
      const { data } = this.data;
      return data ? data.map((item) => item.from_date) : [];
    },
  },
};
</script>
